var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('img',{attrs:{"src":_vm.thirdData.qrCode}}),_vm._v(" "),_c('p',[_vm._v("关注官方"+_vm._s(_vm.thirdData.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }